export default "__VITE_ASSET__7GVjs0de__"